var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulletedList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.60005 4.59995C5.60005 4.93115 5.86885 5.19995 6.20005 5.19995H13.8C13.9592 5.19995 14.1118 5.13674 14.2243 5.02422C14.3368 4.91169 14.4 4.75908 14.4 4.59995C14.4 4.44082 14.3368 4.28821 14.2243 4.17569C14.1118 4.06317 13.9592 3.99995 13.8 3.99995H6.20005C6.04092 3.99995 5.88831 4.06317 5.77578 4.17569C5.66326 4.28821 5.60005 4.44082 5.60005 4.59995ZM0.800049 4.59995C0.800049 3.82715 1.42165 3.19995 2.20005 3.19995C2.97285 3.19995 3.60005 3.82155 3.60005 4.59995C3.60005 5.37275 2.97845 5.99995 2.20005 5.99995C1.42725 5.99995 0.800049 5.37835 0.800049 4.59995ZM5.60005 11.8C5.60005 12.1312 5.86885 12.4 6.20005 12.4H13.8C13.9592 12.4 14.1118 12.3367 14.2243 12.2242C14.3368 12.1117 14.4 11.9591 14.4 11.8C14.4 11.6408 14.3368 11.4882 14.2243 11.3757C14.1118 11.2632 13.9592 11.2 13.8 11.2H6.20005C6.04092 11.2 5.88831 11.2632 5.77578 11.3757C5.66326 11.4882 5.60005 11.6408 5.60005 11.8ZM0.800049 11.8C0.800049 11.0272 1.42165 10.4 2.20005 10.4C2.97285 10.4 3.60005 11.0216 3.60005 11.8C3.60005 12.5728 2.97845 13.2 2.20005 13.2C1.42725 13.2 0.800049 12.5784 0.800049 11.8Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulletedList);
export default __webpack_public_path__ + "static/media/bulletedList.09fe971088f7a27d4ef1eebc4d0f00a3.svg";
export { ForwardRef as ReactComponent };